import React, { useEffect, useState } from 'react';
import { 
  Container, 
  Table, 
  TableHead, 
  TableBody, 
  TableCell, 
  TableRow, 
  TextField, 
  Grid, 
  Button, 
  Pagination, 
  CircularProgress, 
  Typography,
  Paper,
  Box,
  Alert
} from '@mui/material';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

function FullInventorySalas() {
  const [datosGenerados, setDatosGenerados] = useState([]);
  const [filtroTexto, setFiltroTexto] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 200;
  const { user } = useSelector(state => state.auth);
  const [orientation, setOrientation] = useState('portrait');

  const fetchData = async () => {
    try {
      setLoading(true);
      setError(null);
      
    //   if (!user?.UserNickName) {
    //     throw new Error("No se encontró información de usuario");
    //   }

      const datos = {
        Token: "TOKEN_DE_EJEMPLO",
        Ambiente: "DESA",
        Dispositivo: {
          Marca: "SAMSUNG",
          Modelo: "S22002B",
          Version: "Android 18.125",
          McAdress: null,
          PowerStatus: "84%",
          WifiStatus: "Conected to iphone de Mauricio",
          GPSStatus: "ON",
          GPS: "321|-485|321"
        },
        Usr: {
          Codigo: "",
          UserNickName: user.UserNickName
        },
        DatosMetodo: {
          NombreMetodo: "ListaReportesSalas",
          Datos_Recibidos: `{"Vista":"InventarioSalasWeb"}`
        }
      };

      const response = await fetch(`https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(JSON.stringify(datos))}`);
      
      if (!response.ok) {
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      
      if (!data?.datos_Generados) {
        throw new Error("Estructura de datos incorrecta");
      }

      const parsedData = JSON.parse(data.datos_Generados);
      
      if (!Array.isArray(parsedData)) {
        throw new Error("Los datos no son un array válido");
      }

      setDatosGenerados(parsedData);
      
    } catch (error) {
      console.error( error);
      setError(error.message || "Error al cargar los datos");
      setDatosGenerados([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [user?.UserNickName]);

  const filteredData = datosGenerados.filter(item => {
    if (!item || !item.itemcode || !item.itemname) return false;
    const searchValue = filtroTexto.toLowerCase();
    return (
      item.itemcode.toLowerCase().includes(searchValue) ||
      item.itemname.toLowerCase().includes(searchValue)
    );
  });
  

  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const exportToPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: 'mm'
    });
  
    // Configuración de estilos
    const styles = {
      header: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: 'bold',
        fontSize: 10
      },
      body: {
        textColor: 0,
        fontSize: 8
      },
      alternateRow: {
        fillColor: [240, 240, 240]
      }
    };
  
    // Configuración de columnas
    const columns = [
      { header: 'Código', dataKey: 'itemcode', width: 20 },
      { header: 'Descripción', dataKey: 'itemname', width: 40 },
      { header: 'TZ10 F', dataKey: 'TZ10', width: 15 },
      { header: 'TZ10 T', dataKey: 'TZ10_TRANSITO', width: 15 },
      { header: 'TPRR F', dataKey: 'TPRR', width: 15 },
      { header: 'TPRR T', dataKey: 'TPRR_TRANSITO', width: 15 },
      { header: 'TCSV F', dataKey: 'TCSV', width: 15 },
      { header: 'TCSV T', dataKey: 'TCSV_TRANSITO', width: 15 },
      { header: 'TSCR F', dataKey: 'TSCR', width: 15 },
      { header: 'TSCR T', dataKey: 'TSCR_TRANSITO', width: 15 },
      { header: 'TMIR F', dataKey: 'TMIR', width: 15 },
      { header: 'TMIR T', dataKey: 'TMIR_TRANSITO', width: 15 },
      { header: 'TXLA F', dataKey: 'TXLA', width: 15 },
      { header: 'TXLA T', dataKey: 'TXLA_TRANSITO', width: 15 },
      { header: 'Total F', dataKey: 'TOTAL_FISICO_TIENDAS', width: 20 },
      { header: 'Total T', dataKey: 'TOTAL_TRANSITO', width: 20 }
    ];
  
    // Título del documento
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    doc.text('INVENTARIO GLOBAL SALAS WEB', 14, 10);
  
    // Fecha y usuario
    doc.setFontSize(8);
    doc.text(`Generado por: ${user?.UserNickName || 'Sistema'} - ${new Date().toLocaleString()}`, 14, 16);
  
    // Tabla de datos
    doc.autoTable({
      startY: 20,
      columns: columns,
      body: filteredData,
      styles: styles.body,
      headerStyles: styles.header,
      alternateRowStyles: styles.alternateRow,
      margin: { top: 20 },
      tableWidth: orientation === 'portrait' ? 'wrap' : 'auto'
    });
  
    doc.save(`Inventario_Salas_${new Date().toISOString().slice(0,10)}.pdf`);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Inventario");
    XLSX.writeFile(workbook, "inventario_salas.xlsx");
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const styles = {
    select: {
      '& .MuiSelect-select': {
        py: 1,
        fontSize: '0.875rem'
      }
    }
  };
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold' }}>
        INVENTARIO GLOBAL SALAS WEB
      </Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Buscar por artículo o código"
            variant="outlined"
            fullWidth
            value={filtroTexto}
            onChange={(e) => setFiltroTexto(e.target.value)}
            disabled={loading}
          />
        </Grid>
        <Grid item xs={12} md={6} sx={{ display: 'flex', gap: 1 }}>
          <Button 
            variant="contained" 
            onClick={fetchData}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? 'Actualizando...' : 'Actualizar'}
          </Button>
          <Button 
            variant="contained" 
            color="warning" 
            onClick={exportToPDF}
            disabled={loading || filteredData.length === 0}
          >
            PDF
          </Button>
          <Button 
            variant="contained" 
            color="success" 
            onClick={exportToExcel}
            disabled={loading || filteredData.length === 0}
          >
            Excel
          </Button>
        </Grid>
      </Grid>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error} - <Button onClick={fetchData} color="inherit">Reintentar</Button>
        </Alert>
      )}

      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 10 }}>
          <CircularProgress size={60} />
        </Box>
      ) : (
        <>
          <Paper sx={{ width: '100%', overflow: 'auto', maxHeight: '70vh' }}>
            <Table stickyHeader sx={{ minWidth: 1500 }}>
              <TableHead>
                <TableRow sx={{ position: 'sticky', top: 0, zIndex: 3, bgcolor: 'background.paper' }}>
                  <TableCell colSpan={2}></TableCell>
                  <TableCell align="center" colSpan={2}>TZ10</TableCell>
                  <TableCell align="center" colSpan={2}>TPRR</TableCell>
                  <TableCell align="center" colSpan={2}>TCSV</TableCell>
                  <TableCell align="center" colSpan={2}>TSCR</TableCell>
                  <TableCell align="center" colSpan={2}>TMIR</TableCell>
                  <TableCell align="center" colSpan={2}>TXLA</TableCell>
                  <TableCell align="center" colSpan={2}>TOTAL</TableCell>
                </TableRow>
                <TableRow sx={{ position: 'sticky', top: 53, zIndex: 2, bgcolor: 'background.paper' }}>
                  <TableCell sx={{ fontWeight: 'bold' }}>Código</TableCell>
                  <TableCell sx={{ fontWeight: 'bold' }}>Descripción</TableCell>
                  <TableCell align="center">SAP</TableCell>
                  <TableCell align="center">Tránsito</TableCell>
                  <TableCell align="center">SAP</TableCell>
                  <TableCell align="center">Tránsito</TableCell>
                  <TableCell align="center">SAP</TableCell>
                  <TableCell align="center">Tránsito</TableCell>
                  <TableCell align="center">SAP</TableCell>
                  <TableCell align="center">Tránsito</TableCell>
                  <TableCell align="center">SAP</TableCell>
                  <TableCell align="center">Tránsito</TableCell>
                  <TableCell align="center">SAP</TableCell>
                  <TableCell align="center">Tránsito</TableCell>
                  <TableCell align="center">En SAP </TableCell>
                  <TableCell align="center">En Tránsito</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedData.map((item, index) => (
                  <TableRow key={index} hover>
                    <TableCell>{item.itemcode}</TableCell>
                    <TableCell>{item.itemname}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'primary.main', color: 'white' }}>{item.TZ10}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'primary.light', color: 'white' }}>{item.TZ10_TRANSITO}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'warning.main', color: 'white' }}>{item.TPRR}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'warning.light', color: 'white' }}>{item.TPRR_TRANSITO}</TableCell>
                    <TableCell align="center">{item.TCSV}</TableCell>
                    <TableCell align="center">{item.TCSV_TRANSITO}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'info.main', color: 'white' }}>{item.TSCR}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'info.light', color: 'white' }}>{item.TSCR_TRANSITO}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'secondary.main', color: 'white' }}>{item.TMIR}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'secondary.light', color: 'white' }}>{item.TMIR_TRANSITO}</TableCell>
                    <TableCell align="center">{item.TXLA}</TableCell>
                    <TableCell align="center">{item.TXLA_TRANSITO}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'success.main', color: 'white' }}>{item.TOTAL_FISICO_TIENDAS}</TableCell>
                    <TableCell align="center" sx={{ bgcolor: 'success.light', color: 'white' }}>{item.TOTAL_TRANSITO}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>

          {filteredData.length > 0 && (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Pagination
                count={Math.ceil(filteredData.length / rowsPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                color="primary"
                size="large"
                disabled={loading}
              />
            </Box>
          )}
        </>
      )}

      {!loading && !error && filteredData.length === 0 && (
        <Typography variant="h6" textAlign="center" sx={{ my: 5 }}>
          No se encontraron resultados
        </Typography>
      )}
    </Container>
  );
}

export default FullInventorySalas;